// extracted by mini-css-extract-plugin
export default {"modal":"ModalTemplateSecond_modal__JjL7K","pattern":"ModalTemplateSecond_pattern__-NAqE","container":"ModalTemplateSecond_container__ue5Vz","main":"ModalTemplateSecond_main__P8JPi"};